import { render, staticRenderFns } from "./_base-radio-button.vue?vue&type=template&id=40f3727d&scoped=true&"
import script from "./_base-radio-button.vue?vue&type=script&lang=js&"
export * from "./_base-radio-button.vue?vue&type=script&lang=js&"
import style0 from "./_base-radio-button.vue?vue&type=style&index=0&id=40f3727d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40f3727d",
  null
  
)

export default component.exports